<template>
  <v-card>
    <v-card color="#bf0909" class="px-4 py-2" style="box-shadow:none; border-radius: 0">
      <v-row align="center" justify="center">
        <v-col fluid>
          <v-list-item-avatar color="#c62828" size="60" class="ma-0">
            <GobIcon size="40" color="#ffffff"></GobIcon>
          </v-list-item-avatar>
          <span class="headline white--text ma-4">MINEDU</span>
        </v-col>
      </v-row>
    </v-card>
    <v-tabs background-color="#9E0808" color="#fff" dark>
      <v-tab>Generar Json</v-tab>
      <v-tab>Enviar Json</v-tab>
      <v-tab-item>
        <MinGenerarJson></MinGenerarJson>
      </v-tab-item>
      <v-tab-item>
        <MinEnviarJson></MinEnviarJson>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import GobIcon from "../../components/GobIcon"
import MinGenerarJson from '@/components/Minedu/GenerarJson.vue'
import MinEnviarJson from '@/components/Minedu/EnviarJson.vue'

export default {
  name: "Minedu",
  components: {GobIcon, MinGenerarJson, MinEnviarJson},
  data: () => ({

  }),
  mounted(){

  },
  methods: {

  }
}
</script>

<style>

</style>